// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "dialog-ZDDsI";
var _4 = "dialog__content-1mkAG";
var _5 = "header__title-m_CmY";
var _6 = "header__rulesPrice-63k60";
var _7 = "price_withRules-3rB1q";
var _8 = "dialog__button_done-3PH6w";
var _9 = "dialog__button_clear-1rE_y";
var _a = "popupHeader-2wqqo";
var _b = "paper-3tTYH";
export { _1 as "__esModule", _2 as "tablet", _3 as "dialog", _4 as "dialog__content", _5 as "header__title", _6 as "header__rulesPrice", _7 as "price_withRules", _8 as "dialog__button_done", _9 as "dialog__button_clear", _a as "popupHeader", _b as "paper" }
export default { "__esModule": _1, "tablet": _2, "dialog": _3, "dialog__content": _4, "header__title": _5, "header__rulesPrice": _6, "price_withRules": _7, "dialog__button_done": _8, "dialog__button_clear": _9, "popupHeader": _a, "paper": _b }
